const initMegaMenu = () => {
    const megaMenuContainer = document.querySelector("[data-mega-menu-container]");
    const megaMenuLayer = document.querySelector("[data-mega-menu-layer]");
    const megaMenuTogglerContainer = document.querySelector("[data-menu-toggler-container]");
    if (megaMenuContainer && megaMenuTogglerContainer) {
        megaMenuTogglerContainer.addEventListener("click", () => {
            megaMenuContainer.classList.toggle("active");
            megaMenuLayer.classList.toggle("active");
            megaMenuTogglerContainer.childNodes.forEach((child) => child instanceof SVGElement && child.classList.toggle("active"));
            megaMenuTogglerContainer.classList.toggle("active");
        });
    }
};
